// extracted by mini-css-extract-plugin
export default {"footer":"import_modal_footer-module___footer___cb080ec0","rightButtons":"import_modal_footer-module___rightButtons___a15a4690"};